var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',{attrs:{"size":_vm.size,"color":"grey lighten-4"}},[_c('v-img',{attrs:{"src":_vm.contactPhoto,"alt":"avatar","aspect-ratio":"1"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }